import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ButtonComponent } from '@oneqrew-partnertool/button';
import { environment } from '@oneqrew-partnertool/config';
import { selectCustomer, selectPlan, setPlan } from '@oneqrew-partnertool/core';
import { Customer, Plan } from '@oneqrew-partnertool/models';
import { PrimeNgModule } from '@oneqrew-partnertool/primeng';
import { PageGuard, PlanCalculatorService, RouteParam, SharedModule } from '@oneqrew-partnertool/utils';
import { RecaptchaModule } from 'ng-recaptcha-2';
import { debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import * as orderSummaryData from '../../../../../shared-assets/data/order-summary.json';
import * as planPackageData from '../../../../../shared-assets/data/shared/plan-package-data';
import { CheckboxModule } from 'primeng/checkbox';
import { LegacyService } from '../../../../../data-access/api-client/src/lib/api/legacy.service';
import { BssLegacyProductDiscount } from '../../../../../data-access/api-client/src/lib/model/bssLegacyProductDiscount';
import { BssLegacyProductPackage } from '../../../../../data-access/api-client/src/lib/model/bssLegacyProductPackage';
@Component({
  selector: 'lib-package-summary',
  standalone: true,
  imports: [SharedModule, PrimeNgModule, RecaptchaModule, ButtonComponent, CheckboxModule, FormsModule],
  templateUrl: './package-summary.component.html',
  styleUrl: './package-summary.component.scss'
})
export class PackageSummaryComponent implements OnInit {
  @Output() offerSummaryForm = new EventEmitter<FormGroup>();
  @Input() isNewCustomer = false;
  @Input() offerFormValid!: boolean;
  class = 'package-summary';
  orderSummaryData = orderSummaryData;
  recaptchaSiteKey = environment.landingPage.recaptcha;
  userID: string = '';
  plan$!: Observable<Plan>;
  customer!: Customer;
  plan!: Plan;
  offerSummaryFormGroup!: FormGroup;
  monthlyCostSum?: number;
  handleBtnClicked: boolean = false;
  legacyProductDiscounts: BssLegacyProductDiscount[] = [];
  oldPlanVersionSelect: BssLegacyProductPackage[] = [];
  selectedPlanVersion!: BssLegacyProductPackage;
  hasOldPlanVersion: boolean = false;
  comment: string = '';

  constructor(
    public planCalculatorService: PlanCalculatorService,
    private store: Store,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private legacyService: LegacyService
  ) {}

  get oldPlanDiscount(): number | null {
    return this.hasOldPlanVersion ? this.selectedLegacyProductDiscount?.discount ?? 0 : null;
  }

  get selectedLegacyProductDiscount(): BssLegacyProductDiscount | null {
    return this.hasOldPlanVersion
      ? this.legacyProductDiscounts.find(
          (d) => d.legacyProductPackage?.id == this.selectedPlanVersion.id && d.productPackage?.type == this.plan.packageType
        ) || null
      : null;
  }

  get showOldDiscountNote(): boolean {
    return (
      this.selectedLegacyProductDiscount?.legacyProductPackage != undefined &&
      this.selectedLegacyProductDiscount?.legacyProductPackage?.id != planPackageData.TOPHANDWERK_MIT_PFLEGEVERTAG &&
      this.selectedLegacyProductDiscount?.legacyProductPackage?.id != planPackageData.NO_OLD_PACKAGE_PLAN &&
      (this.selectedLegacyProductDiscount?.discount ?? 0) > 0
    );
  }

  ngOnInit(): void {
    this.plan$ = this.store.select(selectPlan);
    this.store.select(selectCustomer).subscribe((customer) => (this.customer = customer));
    this.loadLegacyProductDiscounts(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)); // Default current date, start of contract next month
    this.plan$.subscribe((plan) => {
      this.monthlyCostSum = Number(this.planCalculatorService.getTotal(plan, this.isNewCustomer).toFixed(2));
      if (plan.startDate!! && plan.startDate != this.plan.startDate) {
        this.loadLegacyProductDiscounts(Plan.getStartOfContract(plan, this.isNewCustomer));
      }
      this.plan = plan;
    });

    let setMonthlyPrice = {
      ...this.plan,
      monthlyCostSum: this.monthlyCostSum
    };

    this.store.dispatch(setPlan(setMonthlyPrice));

    this.userID = RouteParam.getParamAsString(this.route, 'id');

    this.offerSummaryFormGroup = this.fb.group({
      legacyProductDiscount: [this.selectedLegacyProductDiscount],
      comment: ['']
    });
    this.offerSummaryForm.emit(this.offerSummaryFormGroup);
  }

  oldPlanVersionChange() {
    this.offerSummaryFormGroup.patchValue({
      legacyProductDiscount: this.selectedLegacyProductDiscount
    });
    this.offerSummaryForm.emit(this.offerSummaryFormGroup);
  }

  hasOldPlanChckBxChange(event: any) {
    if (!event.checked) {
      this.oldPlanVersionChange();
    }
  }

  private loadLegacyProductDiscounts(startOfContract: Date) {
    this.hasOldPlanVersion = false;
    this.legacyService.getAllLegacyProductDiscounts(startOfContract).subscribe((legacyProductDiscounts) => {
      this.legacyProductDiscounts = legacyProductDiscounts;
      this.oldPlanVersionSelect = Array.from(
        new Map(legacyProductDiscounts.map((l) => [l.legacyProductPackage.id, l.legacyProductPackage])).values()
      );
      this.selectedPlanVersion = this.oldPlanVersionSelect[0];
    });
  }
}
